import { api_postValueOrErrorMessage } from "./util";
import version from "../version.json";
import { USER } from "../Hook/user";

function errorMessage(error: unknown) {
  return error instanceof Error ? error.message : String(error);
}

function errorStack(error: unknown) {
  return error instanceof Error ? error.stack ?? "" : "";
}

export async function api_logError(error: unknown, componentStack: string): Promise<void> {
  try {
    const location = window.location;
    const context = {
      source: "react_error_boundary",
      componentStack,
      url: `${location.origin}${location.pathname}`,
      version: version.version,
      userId: USER.informations?.id,
      userAgent: navigator.userAgent,
    };

    await api_postValueOrErrorMessage("support/crashes/add", {
      message: errorMessage(error),
      stacktrace: errorStack(error),
      context: JSON.stringify(context),
    });
  } catch {
    // Crash reporting must never introduce another application failure.
  }
}

export function api_logErrorPayment(data: any){
  api_postValueOrErrorMessage("support/crashes/add", {
    message: "payment_failed",
    stacktrace: "",
    context: JSON.stringify(data)
  });
}
